export enum AudienceModeType {
  Basic = "basic",
  Advance = "advance",
}
